export default {
    add_oem_title: "Adicionar OEM",
    add_oem_save_oem: "Guardar OEM",
    add_oem_type: "Seleccione el OEM a adicionar",
    add_oem_cerebrumX: "CerebrumX",
    add_oem_diesellaptops: "Diesel Laptops",
    "add_oem_wex-ws" : "WEX-WS",
    add_oem_fanid:"Fan ID",
    add_oem_success_message: "OEM adicionado correctamente",
    add_oem_error_message: "Hubo un error al adicionar el OEM"

}